import React, { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { isLoggedIn, setUser } from '../lib/auth'

export default function ConfirmEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('confirmation_token')
  const [status, setStatus] = useState('confirming')
  const [error, setError] = useState(null)
  const loggedIn = isLoggedIn()

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setError('Missing confirmation token.')
      return
    }

    fetch(`/api/confirmation?confirmation_token=${encodeURIComponent(token)}`)
      .then(async (res) => {
        const data = await res.json()
        if (res.ok) {
          if (data.user && loggedIn) {
            setUser(data.user)
          }
          setStatus('confirmed')
        } else {
          setStatus('error')
          setError(data.errors?.join(', ') || 'Confirmation failed')
        }
      })
      .catch(() => {
        setStatus('error')
        setError('Something went wrong. Please try again.')
      })
  }, [token])

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="MyWrenchLog" className="h-16 w-auto mb-3" />
          <h1 className="text-3xl font-bold text-ink">MyWrenchLog</h1>
        </div>

        <div className="bg-surface border-[1.5px] border-ink p-6">
          {status === 'confirming' && (
            <p className="text-sm text-gray-500 text-center">Confirming your email...</p>
          )}

          {status === 'confirmed' && (
            <div>
              <h2 className="text-xl font-extrabold text-ink mb-4">Email Confirmed</h2>
              <p className="text-sm text-ink bg-surface p-3 rounded mb-4">
                Your email has been verified.
              </p>
              <Link
                to={loggedIn ? '/account' : '/login'}
                className="block w-full py-2 px-4 text-sm font-medium text-center text-white bg-accent rounded-md hover:bg-accent-dark"
              >
                {loggedIn ? 'Go to Account' : 'Sign in'}
              </Link>
            </div>
          )}

          {status === 'error' && (
            <div>
              <h2 className="text-xl font-extrabold text-ink mb-4">Confirmation Failed</h2>
              <p className="text-sm text-accent-dark bg-accent/10 border border-accent/40 p-3 mb-4">{error}</p>
              <div className="space-y-2">
                <Link
                  to="/resend-confirmation"
                  className="block w-full py-2 px-4 text-sm font-medium text-center text-white bg-accent rounded-md hover:bg-accent-dark"
                >
                  Resend Confirmation Email
                </Link>
                <Link
                  to={loggedIn ? '/account' : '/login'}
                  className="block text-sm text-center text-accent hover:text-accent-dark"
                >
                  {loggedIn ? 'Go to Account' : 'Back to Sign in'}
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
